"use strict";

exports.__esModule = true;
exports.URLFilterController = void 0;
var _react = require("react");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _querystring = require("querystring");
var _class, _URLFilterController;
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var isEmpty = require("ramda").isEmpty;
function getLocationQuery(location) {
  var search = location.search;
  if (search == null || search.length === 0 || !search.startsWith("?")) {
    return {};
  }
  return (0, _querystring.parse)(search.slice(1));
}
function getFiltersFromLocation(location, params) {
  var filters = {};
  var query = getLocationQuery(location);
  for (var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var param = params[key];
    if (key in query) {
      var value = query[key];
      if (!param.multiple && Array.isArray(value)) {
        if (value.length === 0) {
          if (param["default"] !== undefined) {
            filters[key] = param["default"];
          }
          continue;
        }
        // eslint-disable-next-line prefer-destructuring
        value = value[0];
      } else if (param.multiple && !Array.isArray(value)) {
        value = [value];
      }
      if (typeof param.parser === "function") {
        if (Array.isArray(value)) {
          filters[key] = value.map(param.parser);
        } else {
          filters[key] = param.parser(value);
        }
      } else {
        filters[key] = value;
      }
    } else if ("default" in param) {
      filters[key] = param["default"];
    }
  }
  if (query.term) {
    filters.term = query.term;
  }
  Object.keys(query).forEach(function (key) {
    if (Object.keys(filters).indexOf(key) < 0) {
      filters[key] = query[key];
    }
  });
  return filters;
}

/**
 * Provides data filtering to components, with selected filters
 * being applied to and derived from the URL.
 */
var URLFilterController = exports.URLFilterController = (0, _reactRouterCompat.withRouter)(_class = (_URLFilterController = /*#__PURE__*/function (_Component) {
  function URLFilterController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      setFilter: function setFilter(filterKey, value, action) {
        var _this$props = _this.props,
          replace = _this$props.replace,
          params = _this$props.params,
          location = _this$props.location,
          history = _this$props.history;
        var param = params[filterKey];
        var isDefault = param !== undefined && value === param["default"];
        var query = getLocationQuery(location);
        var updated = {};
        var hasQuery = false;
        for (var _i2 = 0, _Object$keys2 = Object.keys(query); _i2 < _Object$keys2.length; _i2++) {
          var key = _Object$keys2[_i2];
          if (key !== filterKey) {
            hasQuery = true;
            updated[key] = query[key];
          }
        }
        if (!isDefault && !isEmpty(value)) {
          hasQuery = true;
          updated[filterKey] = value;
        }
        var search = hasQuery ? "?" + (0, _querystring.stringify)(updated) : "";
        // Prefer path+search strings for HashRouter (RR6 location objects with empty hash are brittle).
        var to = "" + location.pathname + search;
        if (action) {
          history[action](to);
        } else if (replace) {
          history.replace(to);
        } else {
          history.push(to);
        }
      },
      filters: getFiltersFromLocation(_this.props.location, _this.props.params),
      toQuery: function toQuery() {
        var params = _this.props.params;
        var filters = _this.state.filters;
        var query = {};
        for (var _i3 = 0, _Object$keys3 = Object.keys(filters); _i3 < _Object$keys3.length; _i3++) {
          var key = _Object$keys3[_i3];
          var value = filters[key];
          var param = params[key];
          var isDefault = param !== undefined && value === param["default"];
          if (!isDefault) {
            query[key] = value;
          }
        }
        return query;
      },
      clearFilters: function clearFilters() {
        return _this.setState({
          filters: {}
        });
      }
    };
    return _this;
  }
  _inheritsLoose(URLFilterController, _Component);
  URLFilterController.getDerivedStateFromProps = function getDerivedStateFromProps(_ref) {
    var location = _ref.location,
      params = _ref.params;
    var filters = getFiltersFromLocation(location, params);
    return {
      filters: filters
    };
  };
  var _proto = URLFilterController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return URLFilterController;
}(_react.Component), _URLFilterController.defaultProps = {
  replace: false,
  history: undefined,
  location: undefined
}, _URLFilterController)) || _class;